"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PauseOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var PauseOutlineSVG = function PauseOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M12 25h-2a2 2 0 01-2-2V9a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2zM10 9v14h2V9zM22 25h-2a2 2 0 01-2-2V9a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2zM20 9v14h2V9z"
  }));
};
exports.PauseOutlineSVG = PauseOutlineSVG;
PauseOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(PauseOutlineSVG);
exports.default = _default;